"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reverterContractABI = exports.reverterContractSource = void 0;
exports.reverterContractSource = `
pragma solidity ^0.8.0;

contract ReverterContract {
  function doRevert() public pure {
    revert();
  }

  function revertOnOdd(uint num) public {
      require(num % 2 == 0, "Expected num to be even.");
  }
}
`;
exports.reverterContractABI = {
    contractName: 'Reverter',
    abi: [
        {
            inputs: [],
            name: 'doRevert',
            outputs: [],
            stateMutability: 'pure',
            type: 'function',
        },
        {
            inputs: [
                {
                    internalType: 'uint256',
                    name: 'num',
                    type: 'uint256',
                },
            ],
            name: 'revertOnOdd',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function',
        },
    ],
    // eslint-disable-next-line max-len
    bytecode: '608060405234801561001057600080fd5b50610233806100206000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c8063afc874d21461003b578063afca433014610045575b600080fd5b610043610061565b005b61005f600480360381019061005a91906100cd565b610066565b005b600080fd5b60006002826100759190610158565b146100b5576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016100ac9061011d565b60405180910390fd5b50565b6000813590506100c7816101e6565b92915050565b6000602082840312156100e3576100e26101b8565b5b60006100f1848285016100b8565b91505092915050565b600061010760188361013d565b9150610112826101bd565b602082019050919050565b60006020820190508181036000830152610136816100fa565b9050919050565b600082825260208201905092915050565b6000819050919050565b60006101638261014e565b915061016e8361014e565b92508261017e5761017d610189565b5b828206905092915050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601260045260246000fd5b600080fd5b7f4578706563746564206e756d20746f206265206576656e2e0000000000000000600082015250565b6101ef8161014e565b81146101fa57600080fd5b5056fea2646970667358221220a7af284b6a434265ed202816ac7a21848c8ec506b807ec2adc73db5d917e485f64736f6c63430008070033',
};
//# sourceMappingURL=reverter.js.map